<template>
  <div v-if="manufacturerPart">
    <Poptip max-width="320" class="ivu-table-cell-tooltip" transfer>
        <div class="ivu-table-cell-tooltip-content">
          <p v-if="manufacturerPart.part_number || manufacturerPart.name">{{ _.get(manufacturerPart, 'part_number') }} &nbsp; {{ _.get(manufacturerPart, 'name') }}</p>
          <div class="body" v-if="manufacturerPart.mpn || manufacturerPart.brand">
            {{ _.get(manufacturerPart, 'mpn') }} &nbsp; {{ _.get(manufacturerPart, 'brand') }}
          </div>
        </div>
        <div slot="content">
          <Row>
            <Col span="8">Part number</Col><Col span="12">{{_.get(manufacturerPart, 'part_number')}}</Col>
            <Col span="8">MPN</Col><Col span="12">{{_.get(manufacturerPart, 'mpn')}}</Col>
            <Col span="8">Brand</Col><Col span="12">{{_.get(manufacturerPart, 'brand')}}</Col>
            <Col span="8">Specification</Col><Col span="12">{{_.get(manufacturerPart, 'specification')}}</Col>
            <Col span="8">Chinese name</Col><Col span="12">{{_.get(manufacturerPart, 'chinese_name')}}</Col>
            <Col span="8">Name</Col><Col span="12">{{_.get(manufacturerPart, 'name')}}</Col>
          </Row>
        </div>
    </Poptip>
  </div>
</template>

<script>
export default {
  name: 'MaterialSourceModelDisplay',
  props: {
    manufacturerPart: {
      type: Object
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="less" scoped>

</style>
